import ReportSection from '@/models/ReportSection';
import ReportSectionService from '@/services/ReportSectionService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useReportSectionsStore = defineStore('reportSections', {
  state: () => ({}),

  getters: {
    models: () => useRepo(ReportSection),
  },

  actions: {
    async index(projectId: Id) {
      const [data, error] = await ReportSectionService.index(projectId);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async show(reportSectionId: Id) {
      const [data, error] = await ReportSectionService.show(reportSectionId);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async adminIndex() {
      const [data, error] = await ReportSectionService.admin.index();

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async seed() {
      const [data, error] = await ReportSectionService.admin.seed();

      if(error) {
        throw error;
      }

      return data;
    },
  },
});
